import { GridService } from '../shared/grid/grid.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ControlHierarchyBucket } from '../models/controlHierarchyBucket.model';

@Injectable({
    providedIn: 'root'
})
export class ControlHierarchyBucketService extends GridService<ControlHierarchyBucket> {

    constructor(http: HttpClient) {
        super('ControlHierarchyBucket', http);
    }
}
